export default __webpack_public_path__ + "media/images/header-cybre-alt-1089dea26e65eb8249c659d1fb656df2.jpg";